export interface DecimalFormatOptions {
  locale?: string;
  minimumIntegerDigits?: number;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

const defaultOptions: Required<DecimalFormatOptions> = {
  locale: 'en-US',
  minimumIntegerDigits: 1,
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
};

export function formatDecimal(
  value: string | number | null | undefined,
  options?: DecimalFormatOptions
) {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const numberValue = Number(value);

  if (isNaN(numberValue)) {
    return typeof value === 'string' ? value : '';
  }

  const {
    locale,
    minimumIntegerDigits,
    minimumFractionDigits,
    maximumFractionDigits,
  } = {
    ...defaultOptions,
    ...options,
  };

  return numberValue.toLocaleString(locale, {
    minimumIntegerDigits,
    minimumFractionDigits,
    maximumFractionDigits,
  });
}
